//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/UserDefinedTemplate.js";
import "../no/NXObject.js";
let d=[[],[[["value"],"SetRuleType",{},1,0],[["name"],"SetRuleName",{},1,0],[[],"GetRuleType",{R_:{value:''}},0,0],[[],"GetRuleName",{R_:{name:''}},0,0],[["nodeType","xLocation","yLocation"],"CreateRuleNode",{R_:{ruleNode:"UserDefinedTemplate.VisualRuleNode"}},3,0],[["ruleNode"],"DeleteRuleNode",{},1,0]],[]];
SPLM.UserDefinedTemplate.VisualRule = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.UserDefinedTemplate.VisualRule";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.UserDefinedTemplate.VisualRule.RuleType = Object.freeze({
    "External" : "External", "Internal" : "Internal"});

export default SPLM;